var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    enableBackground: "new 0 0 800 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E8F1",
    d: "M666.666,33.334H133.333c-55.229,0-100,44.771-100,100v533.334c0,55.229,44.771,100,100,100h533.333 c55.229,0,100-44.771,100-100V133.334C766.666,78.105,721.897,33.334,666.666,33.334z M700,666.668 C700,685.077,685.075,700,666.666,700H500V466.664h69.205c14.348,0,27.083-9.181,31.623-22.794l14.768-44.3 c5.396-16.189-6.653-32.906-23.716-32.906H500v-66.666c0-16.667,16.666-33.334,33.332-33.334H600 c18.408,0,33.332-14.924,33.332-33.333v-22.866c0-10.768-6.877-20.421-17.289-23.169c-43.693-11.529-82.711-11.529-82.711-11.529 C449.998,175.765,400,233.331,400,283.331v83.333h-66.668c-18.408,0-33.332,14.923-33.332,33.333v33.333 c0,18.41,14.924,33.334,33.332,33.334H400V700H133.333C114.924,700,100,685.077,100,666.668V133.334 c0-18.41,14.924-33.334,33.333-33.334h533.333C685.075,100,700,114.924,700,133.334V666.668z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.bf9d12c8e8246ec22c7afe3df03aa131.svg";
export { ForwardRef as ReactComponent };